module.exports = __webpack_public_path__ + "img/cb-off1.3c5e6404.gif";